"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValuePlaceholder = exports.Value = exports.Input = exports.NoOption = exports.OptionContainer = exports.OptionsContainer = exports.ValueContainer = exports.Action = exports.ActionsContainer = exports.SelectContainer = void 0;
const tslib_1 = require("tslib");
const styled_components_1 = tslib_1.__importDefault(require("styled-components"));
const colorUtils_1 = require("../../../helpers/colorUtils");
const styles_1 = require("../../../styles");
const Flex_1 = tslib_1.__importDefault(require("../../Elements/Flex"));
exports.SelectContainer = (0, styled_components_1.default)(Flex_1.default) `
  position: relative;
  flex-direction: column;
  width: 100%;
  border: 1px solid ${styles_1.Colors.Border};
  border-radius: 3px;
  align-items: center;
  line-height: 1.5;
`;
exports.ActionsContainer = (0, styled_components_1.default)(Flex_1.default) ``;
exports.Action = (0, styled_components_1.default)(Flex_1.default) `
  justify-content: center;
  align-items: center;
  color: ${styles_1.Colors.Secondary};
  padding-left: 0.5rem;
  &:hover {
    color: ${styles_1.Colors.Dark};
  }
`;
exports.ValueContainer = (0, styled_components_1.default)(Flex_1.default) `
  border-radius: 3px;
  width: 100%;
  padding: 0.5rem;
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  transition: box-shadow 0.15s ease-in-out;
  user-select: none;
  color: ${props => (props.disabled ? (0, colorUtils_1.lighten)(styles_1.Colors.Dark, 0.3) : 'inherit')};
  background: ${props => (props.disabled ? styles_1.Colors.Secondary : 'transparent')};
  &:focus-within {
    box-shadow: 0 0 0 2px ${styles_1.Colors.Primary};
    ${exports.Action} {
      color: ${styles_1.Colors.Dark};
    }
  }
`;
exports.OptionsContainer = styled_components_1.default.div `
  position: absolute;
  top: calc(100% + 0.5rem);
  left: 0;
  width: 100%;
  border: 1px solid ${styles_1.Colors.Border};
  border-radius: 3px;
  background: #ffffff;
  box-shadow: 0 2px 8px 0 rgba(89, 99, 109, 0.1);
  z-index: 100;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 200px;
`;
exports.OptionContainer = (0, styled_components_1.default)(Flex_1.default) `
  flex-wrap: nowrap;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.5;
  padding: 0.5rem;
  cursor: pointer;
  user-select: none;
  min-height: fit-content;
  &:hover {
    background: ${(0, colorUtils_1.lighten)(styles_1.Colors.Primary, 0.5)};
  }
`;
exports.NoOption = (0, styled_components_1.default)(exports.OptionContainer) `
  color: ${styles_1.Colors.Secondary};
  cursor: not-allowed;
  &:hover {
    background: inherit;
  }
`;
exports.Input = (0, styled_components_1.default)('input') `
  min-width: fit-content;
  width: 100%;
  border: none;
  background: transparent;
  line-height: 1.5;
`;
exports.Value = (0, styled_components_1.default)(Flex_1.default) `
  color: inherit;
  line-height: 1.5;
  flex-wrap: nowrap;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
exports.ValuePlaceholder = (0, styled_components_1.default)(exports.Value) `
  color: ${(0, colorUtils_1.lighten)(styles_1.Colors.Dark, 0.3)};
`;
